/**
 * Конфигурация кнопок действий для карточки заявки
 * Определяет метаданные каждого действия (иконка, текст, вариант, текст загрузки)
 */

/**
 * Базовые определения действий
 */
export const ACTION_DEFINITIONS = {
    submit: {
        key: 'submit',
        icon: 'fas fa-paper-plane',
        text: 'Отправить',
        variant: 'primary',
        loadingText: 'Отправка...',
        loadingFlag: 'submittingRequest',
        conditionGetter: 'canSubmit',
        isPrimary: true
    },
    save: {
        key: 'save',
        icon: 'fas fa-save',
        text: 'Сохранить',
        variant: 'success',
        loadingText: 'Сохранение...',
        loadingFlag: 'savingRequest',
        conditionGetter: 'canSave',
        isPrimary: true,
        requiresChanges: true // Особое условие: требует наличия изменений
    },
    approve: {
        key: 'approve',
        icon: 'fas fa-check',
        text: 'Согласовать',
        variant: 'outline-success',
        loadingText: 'Согласование...',
        loadingFlag: 'approvingRequest',
        conditionGetter: 'canApprove'
    },
    reject: {
        key: 'reject',
        icon: 'fas fa-times',
        text: 'Отклонить',
        variant: 'outline-danger',
        loadingText: 'Отклонение...',
        loadingFlag: 'rejectingRequest',
        conditionGetter: 'canReject'
    },
    execute: {
        key: 'execute',
        icon: 'fas fa-play',
        text: 'Взять всю заявку в работу',
        variant: 'outline-info',
        loadingText: 'Взятие в работу...',
        loadingFlag: 'executingRequest',
        conditionGetter: 'canExecute'
    },
    enable_self_assign_mode: {
        key: 'enable_self_assign_mode',
        icon: 'fas fa-list-ul',
        text: 'Взять в работу отдельные строки',
        variant: 'outline-primary',
        loadingText: null,
        loadingFlag: null,
        conditionGetter: 'canEnableSelfAssignMode'
    },
    return: {
        key: 'return',
        icon: 'fas fa-undo',
        text: 'Вернуть на доработку',
        variant: 'warning',
        loadingText: 'Возврат...',
        loadingFlag: 'returningRequest',
        conditionGetter: 'canReturn'
    },
    complete: {
        key: 'complete',
        icon: 'fas fa-flag-checkered',
        text: 'На приемку',
        variant: 'success',
        loadingText: 'Отправка на приемку...',
        loadingFlag: 'completingRequest',
        conditionGetter: 'canComplete'
    },
    partially_complete: {
        key: 'partially_complete',
        icon: 'fas fa-tasks',
        text: 'Частично выполнить',
        variant: 'info',
        loadingText: 'Частичное выполнение...',
        loadingFlag: 'partiallyCompletingRequest',
        conditionGetter: 'canPartiallyComplete'
    },
    accept: {
        key: 'accept',
        icon: 'fas fa-check-double',
        text: 'Подтвердить выполнение',
        variant: 'success',
        loadingText: 'Подтверждение...',
        loadingFlag: 'acceptingRequest',
        conditionGetter: 'canAccept'
    },
    accept_partially: {
        key: 'accept_partially',
        icon: 'fas fa-check-circle',
        text: 'Принять частично',
        variant: 'success',
        loadingText: 'Частичное принятие...',
        loadingFlag: 'acceptingPartiallyRequest',
        conditionGetter: 'canAcceptPartially'
    },
    cancel: {
        key: 'cancel',
        icon: 'fas fa-ban',
        text: 'Отменить заявку',
        variant: 'outline-dark',
        loadingText: 'Отмена...',
        loadingFlag: 'cancellingRequest',
        conditionGetter: 'canCancel'
    },
    copy: {
        key: 'copy',
        icon: 'fas fa-copy',
        text: 'Копировать',
        variant: 'outline-secondary',
        loadingText: 'Копирование...',
        loadingFlag: null, // Нет флага загрузки, переход на другую страницу
        conditionGetter: 'canCopy'
    },
    change_status: {
        key: 'change_status',
        icon: 'fas fa-exchange-alt',
        text: 'Изменить статус',
        variant: 'warning',
        loadingText: 'Изменение статуса...',
        loadingFlag: 'changingStatus',
        conditionGetter: 'canChangeStatus'
    }
};

/**
 * Порядок отображения действий
 */
export const ACTIONS_ORDER = [
    'submit',
    'save',
    'approve',
    'reject',
    'execute',
    'enable_self_assign_mode',
    'return',
    'complete',
    'partially_complete',
    'accept',
    'accept_partially',
    'cancel',
    'copy',
    'change_status'
];

/**
 * Первичные действия (всегда видны отдельно)
 */
export const PRIMARY_ACTIONS = ['save', 'submit'];

/**
 * Получить все флаги загрузки
 */
export function getLoadingFlags() {
    return Object.values(ACTION_DEFINITIONS)
        .filter(def => def.loadingFlag)
        .map(def => def.loadingFlag);
}

export default {
    ACTION_DEFINITIONS,
    ACTIONS_ORDER,
    PRIMARY_ACTIONS,
    getLoadingFlags
};
